import UdeskLocales from 'UdeskLocales';
import React, { memo } from 'react';
import { useRequest } from 'ahooks';
import { TreeSelect } from 'udesk-ui';
import { TreeSelectProps } from 'antd';
import { getAgentGroups } from 'src/api/agentGroups';
import { AgentGroupFoundResponse2 } from 'src/api/types';

interface TemplateProps<T extends number | number[]> extends TreeSelectProps<T> {}

const Template: <T extends number | number[]>(
    props: TemplateProps<T>
) => React.ReactElement | null = memo((props) => {
    const { ...restProps } = props;

    const { data } = useRequest(getAgentGroups);

    const transform = (data?: AgentGroupFoundResponse2[]) => {
        return data?.map((d) => {
            return {
                ...d,
                title: d.agentGroupName,
                value: d.id,
                children: d.children ? transform(d.children) : undefined,
            };
        });
    };

    return (
        <TreeSelect
            treeData={transform(data?.data)}
            placeholder={
                /* 请选择客服组 */ UdeskLocales['current'].components.agentGroupSelect.index
                    .pleaseSelectAnAgentGroup
            }
            filterTreeNode={(inputValue, treeNode) => {
                return (treeNode?.props.agentGroupName || '')
                    .toLowerCase()
                    .includes(inputValue.toLowerCase());
            }}
            {...restProps}
        />
    );
});

export default Template;
